import { Link, useLocation } from "react-router-dom";

const steps = [
  { label: "Cart", path: "/cart" },
  { label: "Checkout", path: "/checkout" },
  { label: "Success", path: "/success" },
];

export default function OrderStepper({ currentStep }) {
  const location = useLocation();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between relative">
        {/* Progress Line */}
        <div className="absolute top-5 left-0 w-full h-0.5 bg-slate-200 z-0" />
        <div
          className="absolute top-5 left-0 h-0.5 bg-blue-600 transition-all duration-500 z-0"
          style={{
            width: `${(currentStep / (steps.length - 1)) * 100}%`,
          }}
        />

        {steps.map((step, index) => {
          const isActive = index === currentStep;
          const isCompleted = index < currentStep;

          // Only Cart (0) and Checkout (1) are clickable
          const isClickable = index < 2;

          return (
            <div
              key={step.label}
              className="relative z-10 flex flex-col items-center flex-1"
            >
              {isClickable ? (
                <Link to={step.path}>
                  <StepCircle
                    active={isActive}
                    completed={isCompleted}
                    label={index + 1}
                  />
                </Link>
              ) : (
                <StepCircle
                  active={isActive}
                  completed={isCompleted}
                  label={index + 1}
                />
              )}

              <span
                className={`mt-3 text-sm font-medium ${
                  isActive
                    ? "text-slate-900"
                    : "text-slate-500"
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function StepCircle({ active, completed, label }) {
  return (
    <div
      className={`
        w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold
        transition-all duration-300
        ${
          completed
            ? "bg-blue-600 text-white"
            : active
            ? "border-2 border-blue-600 text-blue-600 bg-white"
            : "border border-slate-300 text-slate-400 bg-white"
        }
      `}
    >
      {completed ? "✓" : label}
    </div>
  );
}